import React, { useEffect, useState } from 'react';
import css from 'components/ant/css/index.module.css';
import { follow, unFollow } from '../../card/header';
import { Avatar as AntAvatar } from 'antd';
import { UsergroupAddOutlined, UserOutlined, UsergroupDeleteOutlined, MessageOutlined } from '@ant-design/icons';
import { useLangContext } from 'components/shared/Lang';
import { useAuthContext } from '../../../shared/Auth';
import ZotzonAvatar from 'components/shared/elements/images/ZotzonAvatar';

const PublicListingHead = ({ account, followers, listingAmount }) => {
  const { t } = useLangContext();
  const { isAuth, signOut, data, accessToken } = useAuthContext();
  const [isLoggedIn, setLoggedIn] = useState(false);
  useEffect(() => setLoggedIn(isAuth), [isAuth]);
  const [followA, setFollow] = React.useState(false);

  useEffect(() => {
    if (followers) {
      const myAcc = followers.find((item) => {
        return item?.id === data?.id;
      });
      setFollow(myAcc?.following.includes(account.id) || false);
    }
  }, [followers]);

  return (
    <div className={css.notCollapsed}>
      <div className={css.cabinetHead}>
        {account && (
          <div className={css.cabinetAvatar}>
            {account.avatar && <ZotzonAvatar src={account.avatar} version='profile' />}
            {!account.avatar && <AntAvatar size={100} icon={<UserOutlined />} />}

            <div style={{ marginTop: '6px' }}>
              {!followA && (
                <a
                  onClick={() => {
                    follow(account.id, accessToken);
                    setFollow(true);
                  }}
                >
                  <UsergroupAddOutlined /> {t('follow')}
                </a>
              )}
              {followA && (
                <a
                  style={{ color: '#484545' }}
                  onClick={() => {
                    unFollow(account.id, accessToken);
                    setFollow(false);
                  }}
                >
                  <UsergroupDeleteOutlined /> {t('unfollow')}
                </a>
              )}
            </div>
          </div>
        )}
        {account && (
          <div
            className={css.cabinetFio}
            style={{
              display: 'inline',
            }}
          >
            <div className={css.fio}>
              {account?.firstName} {account?.lastName}
            </div>
            {account?.country && (
              <div
                className={css.area}
                style={{
                  margin: '12px 0 0 0',
                }}
              >
                {account?.country?.nameEn} {account?.area?.nameEn} {account?.city?.nameEn}
              </div>
            )}
            {account?.phone && (
              <div
                className={css.area}
                style={{
                  margin: '12px 0 0 0',
                }}
              >
                {t('phone')}: {account?.phone}
              </div>
            )}

            {account.description && (
              <div
                className={css.area}
                style={{
                  margin: '12px 0 0 0',
                }}
              >
                {t('description')}: {account?.description}
              </div>
            )}

            {/*{account.links[0] && (*/}
            {/*  <div*/}
            {/*    className={css.area}*/}
            {/*    style={{*/}
            {/*      margin: '12px 0 0 0',*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    {t('link1')}: <a href={account?.links[0]}>{account?.links[0]}</a>*/}
            {/*  </div>*/}
            {/*)}*/}

            {/*{account.links[1] && (*/}
            {/*  <div*/}
            {/*    className={css.area}*/}
            {/*    style={{*/}
            {/*      margin: '12px 0 0 0',*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    {t('link2')}: <a href={account?.links[1]}>{account?.links[1]}</a>*/}
            {/*  </div>*/}
            {/*)}*/}

            {account && (
              <div
                className={css.area}
                style={{
                  margin: '12px 0 0 0',
                  fontWeight: 'normal',
                  display: 'flex',
                  textAlign: 'center',
                  flexWrap: 'wrap',
                  flexDirection: 'row',
                  width: '240px',
                  fontSize: '12px',
                  justifyContent: 'flex-start',
                }}
              >
                <div
                  style={{
                    minWidth: '50px',
                    textAlign: 'center',
                    marginBottom: '6px',
                  }}
                >
                  <div
                    style={{
                      height: '20px',
                      fontWeight: 'bold',
                      fontSize: '14px',
                    }}
                  >
                    {followers.length}
                  </div>
                  <div>{t('follows')}</div>
                </div>
                <div
                  style={{
                    minWidth: '50px',
                    margin: '0 6px',
                    textAlign: 'center',
                  }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      fontSize: '14px',
                      height: '20px',
                    }}
                  >
                    {listingAmount}
                  </div>
                  <a title={t('message')} style={{ color: '#333' }} href={`/users/${account.userName ?? account.id}`}>
                    <span style={{ textDecoration: 'underline' }}>{t('posts')}</span>
                  </a>
                </div>
                <div
                  style={{
                    minWidth: '50px',
                    textAlign: 'center',
                  }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      fontSize: '14px',
                      height: '20px',
                    }}
                  >
                    5.0
                  </div>
                  <div>{t('rating')}</div>
                </div>
                {isLoggedIn && (
                  <div
                    style={{
                      padding: '3px 0 0 0',
                      minWidth: '60px',
                      textAlign: 'center',
                    }}
                  >
                    <a
                      title={t('message')}
                      style={{ color: '#333' }}
                      href={`/chat/users/${account.userName ?? account.id}`}
                    >
                      <MessageOutlined style={{ fontSize: '16px' }} />
                      <br />
                      <span style={{ textDecoration: 'underline' }}>{t('Message')}</span>
                    </a>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PublicListingHead;
